import { type FC, type PropsWithChildren, useState } from 'react';

import { BombEvent } from '../BombEvent/BombEvent';
import { GameOverEvent } from '../GameOverEvent/GameOverEvent';
import { RechargeEnergy } from '../RechargeEnergy/RechargeEnergy';

import { DiceGameModalsContext } from './context';

const DiceGameModals: FC<PropsWithChildren> = ({ children }) => {
  const [isRechargeEnergyOpen, setIsRechargeEnergyOpen] = useState(false);
  const [isBombEventActive, setIsBombEventActive] = useState(false);
  const [isGameOverEventActive, setIsGameOverEventActive] = useState(false);

  const openRechargeEnergy = (): void => {
    setIsRechargeEnergyOpen(true);
  };
  const closeRechargeEnergy = (): void => {
    setIsRechargeEnergyOpen(false);
  };

  const openBombEvent = (): void => {
    setIsBombEventActive(true);
  };

  const closeBombEvent = (): void => {
    setIsBombEventActive(false);
  };

  const closeGameOverEvent = (): void => {
    setIsGameOverEventActive(false);
  };

  const openGameOverEvent = (): void => {
    setIsGameOverEventActive(true);
  };

  return (
    <DiceGameModalsContext.Provider
      value={{
        isRechargeEnergyOpen,
        openRechargeEnergy,
        closeRechargeEnergy,
        isBombEventActive,
        openBombEvent,
        closeBombEvent,
        openGameOverEvent,
        closeGameOverEvent,
        isGameOverEventActive,
      }}
    >
      <RechargeEnergy
        isRechargeEnergyOpen={isRechargeEnergyOpen}
        closeRechargeEnergy={closeRechargeEnergy}
      />
      {isBombEventActive && (
        <BombEvent
          isBombEventActive={isBombEventActive}
          closeBombEvent={closeBombEvent}
        />
      )}
      <GameOverEvent
        isGameOverEventActive={isGameOverEventActive}
        closeGameOverEvent={closeGameOverEvent}
      />
      {children}
    </DiceGameModalsContext.Provider>
  );
};

export { DiceGameModals };
